<template>
  <div v-if="showpage" class="login-wrapper-box" :style="{
    backgroundImage: 'url(' + bgImage + ')',
  }">
    <div class="main-content h-100">
      <div class="auth-layout-wrap position_wrapper">
        <div class="card login-wrapper">
          <div class="p-4">
            <div class="d-flex justify-content-around border-bottom-dotted-gray-1">
              <div class="btn title_color" :class="{ 'font-weight-bold': select == 1 }" @click="select = 1">
                密码登录
              </div>
              <div class="btn title_color" :class="{ 'font-weight-bold': select == 2 }" @click="select = 2">
                短信登录
              </div>
            </div>
            <div v-if="select == 1">
              <b-form @submit.prevent="password_formSubmit">
                <b-form-group>
                  <b-form-input class="mt-3" v-model="form.phone" type="number" required placeholder="请输入手机号"
                    autocomplete="username"></b-form-input>
                </b-form-group>
                <b-form-group>
                  <b-form-input v-model="form.password" placeholder="请输入密码" autocomplete="current-password" required
                    type="password"></b-form-input>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col cols="8" md="8" lg="8" xs="8" sm="8">
                      <b-form-input class="mt-4" placeholder="验证码" required type="text" v-model="form.verifyCode">
                      </b-form-input>
                    </b-col>
                    <b-col cols="4" class="d-flex mt-4" md="4" xs="4" lg="4" sm="4">
                      <img :src="codeUrl" class="captcha" @click="getCode" height="30px" width="70px" />
                    </b-col>
                  </b-row>
                </b-form-group>
                <!--    <div class="mt-3 mb-3 text-right">
                  <router-link to="forgot" tag="a" class="text-muted">
                    <p>
                      <a href class="typo_link text-primary t-font-boldest"
                        >忘记密码?</a
                      >
                    </p>
                  </router-link>
                </div> -->
                <b-button type="submit" block class="login_color" variant="primary" :disabled="loading">登录</b-button>

                <div v-once class="typo__p title_color text-center" style="font-size: 13px">
                  <div class="mt-3 ju">
                    <u @click="select = 2" class="typo_link text-white t-font-boldest">短信登录</u>
                    <u @click="tozhuce" class="typo_link text-white t-font-boldest">快速注册</u>
                  </div>
                </div>

                <!-- <div
                  v-once
                  class="typo__p title_color text-center"
                  style="font-size: 13px"
                >
                  <div class="mt-3">
                    新用户请使用
                    <u
                      @click="select = 2"
                      class="typo_link text-white t-font-boldest"
                      >短信登录</u
                    >
                    完成快速注册

                  </div>
                </div> -->
              </b-form>
            </div>
            <div v-else class="mb-4">
              <b-form @submit.prevent="code_formSubmit">
                <b-form-group>
                  <b-form-input class="mt-3" required type="number" v-model="form.phone" placeholder="请输入手机号"
                    autocomplete="username"></b-form-input>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col cols="7" md="8" lg="8" xs="8" sm="8">
                      <b-form-input placeholder="请输入验证码" v-model="form.phoneCode" type="text" required></b-form-input>
                    </b-col>
                    <b-col class="d-flex" cols="5" md="4" xs="4" lg="4" sm="4">
                      <b-button v-if="countTime == 0" @click="sendCode" class="p-0 h-100 sendCode_color w-100 size_10"
                        variant="primary ripple">发送验证码</b-button>
                      <b-button v-else style="height: 34px; margin-top: 20px" class="p-0 m-0 w-100 text-10"
                        variant="secondary ripple m-1">{{ countTime }}</b-button>
                    </b-col>
                  </b-row>
                </b-form-group>
                <div>
                  <b-button type="submit" block class="login_color" variant="primary" :disabled="loading">登录</b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <a target="_blank" href=" " style="
        display: inline-block;
        text-decoration: none;
        height: 20px;
        line-height: 20px;
        width: 100%;
        text-align: center;
      ">
      <p style="
          height: 20px;
          line-height: 20px;
          margin: 0px 0px 0px 5px;
          color: #939393;
        ">
        <img src="@/assets/imgs/batb.png" />渝公网安备 50010702504783号
      </p>
    </a>
  </div>
</template>
<script>
import Vue from "vue";
import { uuid } from "vue-uuid";
import { isWeixin,getUrlParameter } from "@/utils/common-api.js";
import { Dialog } from 'vant';
export default {
  metaInfo: {
    title: "signIn",
  },
  data() {
    return {
      codeUrl: require("@/assets/imgs/captcha.jpg"),
      showpage: false,
      bgImage: require("@/assets/newindex/newlogin.jpg"),
      loading: false,
      select: 1,
      redirect: undefined,
      countTime: 0,
      timer: null,
      form: {
        userId: "",
        tel: "",
        phone: "",
        phoneCode: "",
        password: "",
        roomId: "",
        verifyCode: "",
      },
    };
  },
  watch: {},
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
    this.timer = null;
  },
  methods: {
    getCode() {
      this.select = 1;
      let uuidV4 = uuid
        .v4()
        .replace("-", "")
        .replace("-", "")
        .replace("-", "")
        .replace("-", "");
      this.form.roomId = uuidV4;
      this.request({
        url: "/v1.0/Account/GetBusinessCode?uuidV4=" + uuidV4,
        method: "GET",
      }).then((res) => {
        if (res.success) {
          this.codeUrl = "data:image/jpg;base64," + res.data.fileContents;
        }
      });
    },
    tozhuce() {
      this.$router.push({
        name: "zhuce",
        query: {
          name: name,
        },
      });
    },
    password_formSubmit(evt) {
      evt.preventDefault();
      this.$toast.loading({
        message: "登录中...",
        forbidClick: true,
      });
      this.form.tel = this.form.phone;
      this.request({
        url: "/v1.0/Account/userPwdLogin",
        method: "POST",
        data: {
          tel: this.form.phone,
          password: this.form.password,
          roomId: this.form.roomId,
          verifyCode: this.form.verifyCode,
        },
      })
        .then((res) => {
          this.$toast.clear();
          if (res.success) {
            this.redirectPush(res.data);
          } else {
            Dialog({ message: res.message });
          }
        })
        .catch((err) => {

          this.$toast.clear();
          Dialog({ message: err });
        });
    },
    sendCode() {
      this.form.tel = this.form.phone;
      if (this.form.phone == "") {
        this.$toast.fail("请输入手机号");
        return false;
      }
      this.request({
        url: "/v1.0/Account/userSendCode",
        method: "POST",
        data: {
          tel: this.form.phone,
        },
      }).then((res) => {
        if (res.success) {
          this.codeTime();
        }
      });
    },
    code_formSubmit(evt) {
      evt.preventDefault();
      this.$toast.loading({
        message: "登录中...",
        forbidClick: true,
      });
      this.form.tel = this.form.phone;
      this.request({
        url: "/v1.0/Account/userTelSMSLogin",
        method: "POST",
        data: {
          tel: this.form.phone,
          smsCode: this.form.phoneCode,
          isThePublic: true,
        },
      })
        .then((res) => {
          if (res.success) {
            this.redirectPush(res.data);
          } else {
            Dialog({ message: res.message });
          }
          this.$toast.clear();
        })
        .catch((err) => { Dialog({ message: err }); });
    },
    codeTime() {
      this.countTime = 60;
      this.timer = setInterval(() => {
        this.countTime -= 1;
        if (this.countTime == 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    redirectPush(data) {
      localStorage.setItem("userInfo", JSON.stringify(data));
      const {
        currentUser: { userType },
        isComplete,
      } = data;
      console.log(userType, 456);
      if (userType == 100) {
        //企业
        if (isComplete == false) {
          this.$router.replace({
            name: "Improveinformation",
          });
        } else {
          this.$router.replace({
            name: "mechanism",
          });
        }
      } else if (userType == 0 || userType == 400 || userType == 300) {
        //招商人员
        this.$router.replace({ name: "investment2" });
      } else if (userType == 200) {
        //专家
        this.$router.replace({
          name: "investment2",
        });
      } else {
        this.$toast.fail("用户类型判断失败,请重新登录。");
      }
    },
  },
  created() {
    if (window.location.host == "zs.tuscq.com") {
      window.location.href = "http://www.jlpzs.cn/";
    }
    this.getCode();
    var user = JSON.parse(localStorage.getItem("userInfo") || "{}");
    if (user.currentUser) {
      this.redirectPush(user);
      return;
    } else {
      let changelogin = localStorage.getItem("changelogin");
      if (changelogin) {
        localStorage.removeItem("changelogin");
        this.showpage = true;
      } else {
        console.log("auth");
        var code = getUrlParameter("code"); // 截取code
        var err = getUrlParameter("err"); // 截取code
        console.log(code, "授权码");
        console.log(err, "err");

        if (code) {
          this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
          });
          this.request({
            url: "/v1.0/wechat/userWeixinLogin",
            method: "POST",
            params: { code: code },
          })
            .then((res) => {
              this.$toast.clear();
              this.redirectPush(res.data);
              return;
            })
            .catch((err) => {
              this.$toast.clear();
              this.showpage = true;
            });
        } else {
          if (err) {
            this.showpage = true;
            return
          }
          var domine = window.location.href.split("#")[0]; // 微信会自动识别#    并且清除#后面的内容
          wx.miniProgram.navigateTo({
            url: `/pages/login-redirect/login-redirect?redirect=${encodeURIComponent(domine)}`,
            success: (res) => {
              console.log(res);   // 页面跳转成功的回调函数
            },
            fail: (err) => {
              console.log(err);   // 页面跳转失败的回调函数
            }
          })
          if (false && isWeixin()) {

            console.log(domine, 5555);
            this.request({
              url: "/v1.0/wechat/AuthUrl",
              method: "POST",
              params: {
                curl: domine,
              },
            })
              .then((res) => {
                console.log(res, 4411);
                if (res.success) {
                  var url = /http\S*t/g.exec(res.data.authUrl);
                  url = url[0].replace(/\\u0026/g, "&");
                  console.log(url);
                  window.location.href = url;
                }
              })
              .catch((err) => {
                this.showpage = true;
                this.getCode();
              });
          } else {
            this.showpage = true;
          }
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";

.title_color {
  color: #ced4da;
  position: relative;
}

.size_10 {
  font-size: 10px;
}

.login_color {
  background: rgb(200, 0, 11) !important;
}

.sendCode_color {
  background: rgb(102, 51, 152) !important;
}

.font-weight-bold {
  color: #ffffff !important;
}

.card {
  border: none !important;
}

.font-weight-bold::after {
  content: "";
  position: absolute;
  width: 64px;
  height: 2px;
  background: white;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.login-wrapper-box {
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;

  .position_wrapper {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .login-wrapper {
    background: rgba(0, 0, 0, 0.1);
    width: 300px;
    margin: 0 auto;
  }
}

.ju {
  display: flex;
  justify-content: space-between;
}
</style>
